import React, { useEffect, useState } from "react";
import Image from "../../components/common/Image";
import "./track.scss";
import Notification from "../../components/common/Error/Notification";
import Payment from "./payment";
import Fee from "../../components/service/fee";
import { GetTokenbyTrade, TakeBill, TakePreBill, PostCancel, GetOrderInfo, TakeCancel,FeedBack } from "../../api/order";
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/common/loading";
import Accordion from "../../components/common/accordion";
// import Detail from "./component/Detail";
import Record from './record'

const Track = () => {
    const navigate = useNavigate();
    const rating_star = [1, 2, 3, 4, 5]
    const [modal, setModal] = useState(null);
    const [preBill, setPreBill] = useState(null);
    const [step, setStep] = useState(1);
    const location = useLocation();
    const [paymentBtn, setPaymentBtn] = useState(false)
    const [paymentToken, setPaymentToken] = useState(null);
    const [rating, setRating] = useState({ rate: 5, comment: ''});
    const [notify, setNotify] = useState(null);
    const searchParams = new URLSearchParams(location.search);
    const paymentStatus = searchParams.get("status");
    const id = searchParams.get("id");
    const [data, setData] = useState(null)
    useEffect(() => {
        if (id) fetchOrderInfo();
    }, []);
  
    const paymentFn = async () => {
        setPaymentBtn(true)
        //若訂單沒有實際費用金額 amount； 再次呼叫確認金額API
        const { cancelAmount, status } = data

        let amount = data.amount
        // 訂單已取消
        if (status === 99) {
            amount = data.cancelAmount || 0;
        } else if (amount) {
            //若訂單無實際金額， 呼叫takebill API 取得最終金額
            const amountRes = await TakeBill({
                tmsCaseid: data.tmsCaseId,
                orderID: data.orderId,
            });
            if (amountRes?.statusCode === 200) {
                amount = amountRes.result.amount;
                await fetchOrderInfo(true)
            }
        }

        if(!data.amount){
            let amountRes = await TakeBill({
                tmsCaseid: data['tmsCaseid'], 
                orderID: data['orderId'],
            })
            if(amountRes?.statusCode === 200){
                amount = amountRes.result.amount
            }
        }
        if (amount) {
            let res = await GetTokenbyTrade(
                {
                    totalAmount: amount * 1,
                    orderID: data.orderId,
                }
            )
            if (res?.statusCode === 200) {
                setNotify(null)
                setPaymentToken(res.result)
                setStep(3)
            } else {
                setNotify({ message: res.message })
            }
        } else {
            setNotify({
                message: "尚未收到刷卡申請", desc: <>
                    請跟現場技師表達有刷卡需求，<br />待技師回覆後請再試一次。
                </>
            })
        }
        setPaymentBtn(false)
    }

    const fetchOrderInfo = async (notRefresh) => {
        if(!notRefresh) setData(null)
        let obj = {};
        if (id) {
            let res = await GetOrderInfo(id)
            if (res?.statusCode === 200) {
                const { serviceEndTime, status, cancelAmount } = res.result
                let valid = moment().isBefore(serviceEndTime)
                if (valid) {
                    obj = res.result
                    if (status === 99) {
                        let cancel = await TakeCancel({ orderID: id })
                        if (cancel?.statusCode === 200) {
                            obj.cancelAmount = cancel.result.price
                        }
                    }
                } else {
                    obj = false
                }
            }
        }
        setData(obj)
        setPreBill(obj.preBillItem? JSON.parse(obj.preBillItem):null)
        // if (obj) {
        //     TakePreBill(obj).then(res => {
        //         if (res?.statusCode === 200) setPreBill(res.result)
        //     })
        // }
    };
    useEffect(() => {
        if (paymentStatus === "1") {
            setNotify({ message: "付款已成功" });
        } else if (paymentStatus === "0") {
            setNotify({
                message: "付款失敗",
                description: "刷卡失敗，請確認卡片資訊是否正確或聯絡發卡銀行。",
                onConfirm: () => {
                    navigate(`/track?id=${id}`)
                    setNotify(null)
                }
            });
        }
    }, [paymentStatus]);
    const getBill = async () => {
        const { status, amount, preBillItem,getBillItem } = data
        // if (amount !== null) {
        //     let res = await TakeBill({
        //         tmsCaseid: data['tmsCaseId'],
        //         orderID: data['orderId'],
        //     })
        //     if (res?.statusCode === 200) {
        //         setPreBill(res.result)
        //         setModal({ type: "fee", data: res.result });
        //     }
        // } else {
        //     let obj = null
        //     if (preBillItem) {
        //         obj = JSON.parse(preBillItem)
        //     } else {
        //         let res = await TakePreBill(data)
        //         if (res?.statusCode === 200) {
        //             obj = res.result
        //         }
        //     }
            setPreBill(getBillItem?JSON.parse(getBillItem):null)
            setModal({ type: "fee", data: JSON.parse(getBillItem) });
        // }

    }
    return (
        <div className="container">
            <Image src="/images/logo.svg" />
            {data ? (<>
                {
                    step === 1 && (
                        <div className="grid-gap-24" style={{ marginBottom: 0 }}>
                            <Accordion
                                defaultValue={{ 1: true }}
                                options={[
                                    {
                                        id: 1,
                                        name: "服務提醒",
                                        description: (
                                            <ul>
                                                <li>
                                                    如為車禍事故案件，建議您先填寫事故備案（點擊下方橘色按鈕），以利後續處理。
                                                </li>
                                                <li>
                                                    本公司提供現金及信用卡付款，請於技師抵達時告知您的付款方式。
                                                </li>
                                                {
                                                    data.serviceName === '接電' && (
                                                        <li>
                                                            提醒您，接電完成後，請您盡快至保養廠檢查您的電瓶，以確保您的行車安全
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                        ),
                                    },
                                ]}
                            />
                            <div className="">
                                <p className="font-heading">{data.serviceName}資訊</p>
                                <p >
                                    {data.paymentStatus !== 2 && (<>
                                        <span className="paid-text"> {data.paymentStatusName}  </span>
                                        <span> | </span>
                                    </>)}

                                    {moment(data.createTime).format(`YYYY年MM月DD日 HH:mm`)}
                                </p>
                            </div>
                            <div className="confirm-block" style={{ marginTop: 0 }}>
                                <div className="block">
                                    <div className="d-flex info_block">
                                        <Image src={`/images/icons/${data.destinationAddress ? 'destination' : 'origin'}.svg`} />
                                        <div className="desc_block">
                                            <div className="desc">
                                                <p className="title">{data.originAddress}</p>
                                                <p className="text">{data.locationType}</p>
                                            </div>
                                            {
                                                data.destinationAddress && (
                                                    <div className='desc'>
                                                        <p className='title'>{data.destinationAddress}</p>

                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="list_block">
                                        <div className="desc_flex">
                                            <Image src="/images/icons/car.svg" />
                                            <div className="title_block">
                                                <p className="title">{data.userCarPlateNum}</p>
                                                <p className="text">
                                                    {data.userCarBrandName} {data.userCarModelName}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    { data.amount && (
                                        <div className="list_block">
                                            <div className="desc_flex">
                                                <Image src="/images/icons/dollar.svg" />
                                                <div className="title_block">
                                                    <p className="title">
                                                        {
                                                            data.status === 99 ? data.cancelAmount : data.amount
                                                        }
                                                    </p>
                                                    <p className="text">
                                                        {
                                                            data.status === 99 ? "取消金額" : data.amount ? "服務費用" : "試算金額"
                                                        }
                                                    </p>
                                                </div>
                                            </div>

                                            {
                                                data.status !== 99 && (
                                                    <div
                                                        onClick={() => getBill()}
                                                    >
                                                        <Image src="/images/icons/chevron_right.svg" svg />
                                                    </div>
                                                )
                                            }

                                        </div>
                                    )}

                                    <div className="list_block">
                                        <div className="desc_flex">
                                            <Image src="/images/icons/tool.svg" />
                                            <div className="title_block">
                                                <p className="title">
                                                    {data.executionDriverName} ({data.executionDriverPlateNum}
                                                    )
                                                </p>
                                                <p className="text">執行技師</p>
                                            </div>
                                        </div>
                                        {/* <div
                                            onClick={() => {
                                                window.open(`tel:${data.executionDriverPhone}`, "_self");

                                            }}
                                        >
                                            <Image src="/images/icons/phone.svg" svg />
                                        </div> */}
                                    </div>
                                    {data.executionDriverLocation && (
                                        <div className="list_block">
                                            <div className="desc_flex">
                                                <Image src="/images/icons/map.svg" />
                                                <div className="title_block">
                                                    <p className="title">查看技師位置</p>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    window.open(data.executionDriverLocation);
                                                }}
                                            >
                                                <Image src="/images/icons/link.svg" svg />
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                            <div>
                                {(data.isAccident && !data.isOrderFilingExist && data.status < 6) && (
                                    <button className="btn btn-primary" onClick={() => setStep(2)}>
                                        填寫事故備案紀錄
                                    </button>
                                )}

                                {
                                    data.paymentStatus === 2 && (
                                        <button
                                            disabled={paymentBtn}
                                            onClick={() => paymentFn()}
                                            className="btn"
                                            style={{ margin: "8px 0" }}>
                                            線上刷卡
                                        </button>
                                    )
                                }

                                {/* 服務完成後都不能取消訂單
                                6：服務完成 、付款完成 status = 7、取消服務 status=99 */}
                                {(data.status < 6) && (
                                    <>
                                        <button
                                            onClick={() => {
                                                if (id) {
                                                    PostCancel({ OrderId: id }).then(res => {
                                                        if (res?.statusCode === 200) {
                                                            fetchOrderInfo()
                                                        }
                                                    })
                                                }
                                            }}
                                            className="btn btn-text">取消服務</button>
                                    </>
                                )}
                            </div>
                        </div>)
                }
                {/* 事故 + 未填寫事故紀錄  + 未付款/未取消 */}
                {step === 2 && (
                    <Record
                        OrderId={data.orderId}
                        setStep={setStep}
                        onSubmit={() => {
                            setStep(1);
                            setNotify({
                                message: "您的產險申報已完成",
                                description: (
                                    <div style={{ textAlign: "left" }}>
                                        <p>1.現場請報警處理</p>
                                        <p>2.請務必記下對方姓名及聯絡電話</p>
                                        <p>3.暫勿私下和解</p>
                                        <p>4.車輛損壞部分請先進場估價，切勿直接進行維修</p>
                                        <p>
                                            5.產險申報僅為報備，並非理賠申請，請您於上班時段儘速洽詢產險公司辦理理賠
                                        </p>
                                    </div>
                                ),
                            });
                        }}
                    />
                )}
                { step === 3 && (
                    <Payment
                        Token={paymentToken}
                        data={data}
                        setStep={setStep}
                        setModal={()=>{
                            getBill()
                        }}
                    />
                ) }
                { modal?.type === "fee" && (
                    <Fee setModal={()=>setModal(null)} 
                    data={modal.data} type={data.amount ? 'actual' : ''} />
                )}
                {
                    notify?.message === '付款已成功' ? (
                        <Notification
                            title='付款成功'
                            description={<>
                                <p>
                                    感謝您選擇我們的服務，期待您的寶貴意見。
                                    <br /> 如有任何建議或需求，歡迎隨時與我們聯繫。
                                </p>
                                <div className="rating">
                                    <div className="rating-block">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <div
                                                key={star}
                                                onClick={() => setRating({ ...rating, rate: star })}
                                                className={star <= rating.rate ? "active" : ""}
                                            >
                                                <Image src="/images/icons/star.svg" svg />
                                            </div>
                                        ))}
                                    </div>
                                    {rating.rate !== 5 && (
                                        <textarea
                                            placeholder="我們期待聽到您的建議！"
                                            onChange={(e) =>
                                                setRating({ ...rating, comment: e.target.value })
                                            }
                                        ></textarea>
                                    )}
                                </div>
                            </>}
                            okText="好"
                            onConfirm={() => {
                                FeedBack({
                                    orderId:id,
                                    feedbackStart:rating.rate,
                                    feedbackComment:rating.comment,
                                }).then(res=>{
                                    if(res?.statusCode === 200){
                                        navigate(`/track?id=${id}`)
                                        setNotify(null)
                                    }
                                })
                            }}
                        />
                    ) : notify ? (
                        <Notification
                            title={notify.message}
                            description={notify.description}
                            okText="好"
                            onConfirm={notify.onConfirm?notify.onConfirm:() => {
                                setNotify(null)
                            }}
                        />
                    ) : (<></>)
                }

            </>) : data === null ? (
                <Loading />
            ) : (
                <div className="expired">
                    <div className="expired_block">
                        <Image src="/images/expired.svg" />
                        <p>服務可能已經結束</p>
                        <button className="btn btn-primary" onClick={() => navigate("/")}>
                            開始新的服務
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Track